import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { DocumentContainer, SignatureContainer, SingnatureResponse } from '../../models/document.model';
import { DocumentService } from '../../services/document.service';
import { UtilityService } from '../../services/shared/utility.service';
import { UserService } from '../../services/user.service';

@Component({
    selector: 'app-contract-signature-list',
    templateUrl: './contract-signature-list.component.html',
    styleUrls: ['./contract-signature-list.component.css']
})
/** contract-signature-list component*/
export class ContractSignatureListComponent implements OnInit {   
    
    signatureResponse: SingnatureResponse;
    signatureListResponse: SignatureContainer[]=[];
    signatureAuditListResponse: SignatureContainer[]=[];
    private encryptedUser: string = '';    
    signatureForm: FormGroup;    
    isData: boolean = false;
    loading: boolean = false;
    /** contract-signature-list ctor */
    constructor(private fb: FormBuilder,
        private _utilityService: UtilityService,
        private _router: Router,
        private _route: ActivatedRoute,
        private _documentService: DocumentService,
        private _userService: UserService,) {


        this._route.queryParamMap.subscribe(params => {
            if (params.has('r')) {
                this.encryptedUser = params.get('r');
                this._userService.getAuthenticateR(this.encryptedUser)
                    .then(res => {
                        if (res) {
                            if (res.isvalid) {
                                console.log("Valid User");
                            } else {
                                this._router.navigate(['/unauthorized']);
                            }
                        } else {
                            this._router.navigate(['/unauthorized']);
                        }
                    })
                    .catch((err: HttpErrorResponse) => {
                        console.log("Client side Error : " + err);
                        this._utilityService.handleErrorResponse(err);
                    });
            }
            else {
                console.log('no r');
                this._router.navigate(['/unauthorized']);
            }
        });
    }
    get form() { return this.signatureForm.controls; }
    ngOnInit() {
        this.signatureForm = this.fb.group({            
            csId: [''],
        });
    }
    searchByCsId() {
        if (this.signatureForm.controls.csId.value === '') {
            this._utilityService.showAlertMsg("Contract session id", "Please enter contrat session id!");
            return;
        }
        this.loading = true;
        this.loadSignatureList(this.signatureForm.controls.csId.value);
    }

    private async loadSignatureList(csId: number) {
        await this._documentService.getSignatureList(csId, this.encryptedUser)
            .then(async (result: SingnatureResponse) => {
                if (result) {
                    this.signatureResponse = UtilityService.clone(result);
                    this.signatureListResponse = this.signatureResponse.signatureContainer;
                    this.signatureAuditListResponse = this.signatureResponse.signatureContainerAudit;
                    this.isData = true;
                    this.loading = false;
                }
                else
                    this.isData = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    allowNumeric(e) {
        if (e.ctrlKey || e.altKey) {
            e.preventDefault();
        } else {
            var key = e.keyCode;
            if (key != 8 && key != 0 && (key < 48 || key > 57)) {
                e.preventDefault();
            }
        }
    }
}
